var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerGameListRestrictTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2l2.077 3.628L14 6.584 11.36 9.78 11.708 14 8 12.348 4.292 14l.348-4.219L2 6.584l3.923-.956L8 2z",
    fill: "#D70A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.555 9.206H7.44L7.283 4.75h1.43l-.158 4.456zm-.557.697c.226 0 .407.063.543.19.14.127.209.289.209.486 0 .194-.07.354-.209.481-.136.127-.317.19-.543.19a.777.777 0 01-.544-.19.629.629 0 01-.204-.481c0-.195.068-.355.204-.482.14-.129.32-.194.544-.194z",
    fill: "#fff"
  })));
}
SvgPokerGameListRestrictTable.displayName = 'PokerGameListRestrictTable';
export default SvgPokerGameListRestrictTable;